import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_MEMBER } from 'src/hooks/accounts/get-current-member-account.hook';

import { GET_GANTTS } from './get-gantts.hook';
import { GET_GANTT_BY_ID } from './get-current-gantt.hook';
import { useCurrentMemberContext } from 'src/contexts';

const UPSERT_GANTTS = gql`
  mutation upsertGantts($payload: [UpsertGanttInput!]!) {
    upsertGantts(payload: $payload) {
      _id
    }
  }
`;

export const useUpsertGantts = () => {
  const { ganttId } = useCurrentMemberContext();

  const [upsertGantts] = useMutation(UPSERT_GANTTS, {
    refetchQueries: [
      GET_GANTTS,
      GET_CURRENT_MEMBER,
      { query: GET_GANTT_BY_ID, variables: { ganttId } },
    ],
  });

  return upsertGantts;
};
